<template>
  <div class="container">
    <!-- 头部部分 -->
    <div class="breadCrumpWrap"  v-if="searchUserName">
        <span class="backBtn" @click="back"> <i class="el-icon-arrow-left"></i> 返回</span>
        <div class="itemBox">
            <span>
                <span class="name">{{searchUserName}}</span>
                <span class="lineIcon">&gt;</span>
                <span class="name">锁仓列表</span>
            </span>
        </div>
    </div>
    <div class="breadCrumpWrap"  v-if="!searchUserName">
        <div class="itemBox">
            <span>
                <span class="name">锁仓列表</span>
            </span>

        </div>
    </div>
    <div class="pageTitleBox" v-if="searchUserName">
      <div class="pageTitleName">{{searchUserName}}</div>
      <div class="rightBtnBox">
        <!-- <el-button type="primary" size="mini" @click="toPageLock">锁仓订单</el-button> -->
        <el-button type="primary" size="mini" @click="toPageOrder">下单订单</el-button>
        <el-button type="primary" size="mini" @click="toPageClear">清算订单</el-button>
      </div>
    </div>
    <div class="searchBox">
      <div class="left">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="ID/商品名称/款号" v-model="formObj.fuzzyQuery" clearable></el-input>
          </el-form-item>
          <el-form-item v-if="!searchUserName">
            <el-select  @change="changeUserOption"
                v-model="searchUser"
                filterable
                placeholder="选择销售商/供应商"
                >
                <el-option
                  v-for="item in options_user"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>

          </el-form-item>

          <el-form-item>
            <el-select v-model="searchBrand" filterable placeholder="请选择品牌">
                <el-option
                  v-for="item in options_brand"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="right">
                <el-button>下载列表</el-button>
      </div>-->
    </div>
    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData" size="small">
        <el-table-column
            align="center"
            label="序号"
            type="index"
            width="80"
            :index="indexMethod"
        >
        </el-table-column>
        <el-table-column
            prop="order_number"
            label="锁仓订单号"
            width="140"
        >
        </el-table-column>
        <el-table-column
        prop="mallItemFileUrl"
        label="图片"
        width="100">
            <template slot-scope="scope">
                <el-image
                    style="width: 64px; height: 64px"
                    :src="scope.row.productMainImageFile"
                    fit="cover"
                    :preview-src-list="[scope.row.productMainImageFile]"
                >
                </el-image>
            </template>
        </el-table-column>
        <el-table-column
            prop="item_name"
            label="商品名称"
            width="120"
        >
        </el-table-column>
        <el-table-column prop="brand" label="品牌" width="70">
        </el-table-column>
        <el-table-column
            prop="item_style_number"
            label="款号"
            width="100"
        >
        </el-table-column>
        <el-table-column
            prop="item_order_price"
            label="价格(元)"
            width="80"
        >
            <template slot-scope="scope">
                {{scope.row.item_order_price}}
            </template>
        </el-table-column>
        <el-table-column
            prop="dealerName"
            label="销售商"
            width="100"
        >
        </el-table-column>
        <el-table-column
            prop="supplierName"
            label="供应商"
            width="100"
        >
        </el-table-column>
        <el-table-column
            prop="reserve_order_submit_time"
            label="发起时间"
            width="90"
        >
        </el-table-column>
        <el-table-column
            prop="order_reserve_quantity"
            label="锁仓数"
            width="80"
        >
        </el-table-column>
        <el-table-column
            prop="order_state"
            label="锁仓状态"
            width="120"
        >
            <template slot-scope="scope">
                <el-tag :type="tagType[scope.row.order_state]" size="medium">{{lockState[scope.row.order_state]}}</el-tag>
            </template>
        </el-table-column>
        <el-table-column
            label="操作"
            min-width="160" fixed="right"
        >
            <template slot-scope="scope">
                <el-button class="cg-icon-btn" @click="toLockDetail(scope.row)" type="text" size="small" v-show="function_lockView">查看</el-button>
                <!-- <el-button class="cg-icon-btn" v-if="scope.row.order_state == 2" @click="toAgreeLock(scope.row)" type="text" size="small">同意</el-button>
                <el-button class="cg-icon-btn" v-if="scope.row.order_state == 2" @click="toRejectLock(scope.row)" type="text" size="small">拒绝</el-button> -->
            </template>
        </el-table-column>

      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="searchObj.page"
        :page-size.sync="searchObj.num"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { ajaxPost, api } from "@/common/request.js"
import { lockOrderState } from '@/common/order-state.js'
import {        utils    } from '@/common/common.js'
export default {
  name: "listOrder",
  data() {
    return {
      isLoading: false,
      formObj: {
        fuzzyQuery: ""
      },
      searchObj: {
        page: 1,
        num: 10
      },
      searchUserName:'',

      searchBrand:'',
      searchUser:'',
      options_user:[],
      options_brand:[],
      //表格
      tableData: [],
      //分页
      total: 0,
      lockState: lockOrderState,
      tagType: {
        0: 'info',
        1: 'success',
        2: 'warning',
        3: 'danger',
        4: 'danger',
        5: 'success'
      }
    };
  },
  computed: {
    IMG_PREV() {
      return api.imgPrev;
    },
    function_lockView() {
      return utils.getCurrentFunction().indexOf("lockView")>-1
    },
    function_lockControl() {
      return utils.getCurrentFunction().indexOf("lockControl")>-1
    },
    function_orderView() {
      return utils.getCurrentFunction().indexOf("orderView")>-1
    },
    function_orderControl() {
      return utils.getCurrentFunction().indexOf("orderControl")>-1
    },
    function_clearView() {
      return utils.getCurrentFunction().indexOf("clearView")>-1
    },
    function_clearControl() {
      return utils.getCurrentFunction().indexOf("clearControl")>-1
    },
  },
  watch: {
    $route: {
      handler: function(route) {
        this.searchObj.num = Number(this.$route.query.size)
          ? Number(this.$route.query.size)
          : 10;
        this.searchObj.page = Number(this.$route.query.page)
          ? Number(this.$route.query.page)
          : 1;

        this.formObj.fuzzyQuery = this.$route.query.search || "";
        this.searchBrand=this.$route.query.searchBrand || "";
        this.searchUser=this.$route.query.searchUser || "";
        this.searchUserName=this.$route.query.searchUserName || "";
        // this.getCurrentOptionByOneUserId(this.searchUser)
        this.getTableLists();
      },
      immediate: true
    }
  },
  components: {},
  methods: {
    toPageLock(){
      this.$router.push("/order/lockList?" +"&searchUser=" +this.searchUser+"&searchUserName="+this.searchUserName)
    },
    toPageOrder(){
      this.$router.push("/order/orderList?" +"&searchUser=" +this.searchUser+"&searchUserName="+this.searchUserName)
    },
    toPageClear(){
      this.$router.push("/order/clearList?" +"&searchUser=" +this.searchUser+"&searchUserName="+this.searchUserName)
    },
    getBrandOption(){
      let _this=this
      let arg={
        userId:this.searchUser
      }
      _this.options_brand =[{text:"所有品牌",value:""}]
      ajaxPost('/commodity/brandListByUser', arg).then(function(res){
        console.log(res)
        if(res.errorCode==200){
          res.data.map(function(item,index){
            let buffer={
              text:item.item_display_name,
              value:item.item_display_name
            }
            _this.options_brand.push(buffer)
          })

        }
      })
    },
    changeUserOption(){//获取品牌-选项
      let _this=this
      this.searchBrand=''
      this.getBrandOption()
    },
    getCurrentOptionByOneUserId(param){
      let _this=this
      if(!param){
        return false
      }
      let userId=param
      let arg={
        userId:userId
      }
      // _this.options_user=[]
      // // 查询基本信息
      // ajaxPost('/admin/getDwUserInfo', arg).then(function(res) {
      //   if(res.errorCode==200){
      //     let resObj=res.data[0]||{}
      //     let name=resObj.user_organization_name||resObj.user_individual_name
      //     let buffer={text:name,value:userId}
      //     _this.options_user.push(buffer)
      //   }
      // }, function(res) {})
      // 查询品牌
      let brandArr=[{text:"所有品牌",value:""}]
      ajaxPost('/commodity/brandListByUser', arg).then(function(res){
        if(res.errorCode==200){
          res.data.map(function(item,index){
            let buffer={
              text:item.item_display_name,
              value:item.item_display_name
            }
            brandArr.push(buffer)
          })
        }else{
          brandArr=[{text:"所有品牌",value:""}]
        }
        _this.options_brand=brandArr
      })

    },
    getOptionUser(query) {//获取选项-用户
      let _this = this
      let newQuery=this.trimAll(query)
      console.log(query,newQuery)
      let arg={
        num: 10000,
        page: 1,
        fuzzyQuery:newQuery
      }
      this.loadingOptionUser = true
      _this.options_user =[]
      ajaxPost('/admin/userList', arg).then(function(res) {
        console.log(res)
        _this.loadingOptionUser = false
        let initOption={text:"全部用户",value:""}
        _this.options_user.push(initOption)
        if (res.data && res.data.userList) {

          res.data.userList.forEach(function(item, index) {
            let buffer={
              // text:( item.user_organization_name||item.user_individual_name)+'-'+item.user_id,
              text:item.user_organization_name||item.user_individual_name,
              value:item.user_id,
            }
            _this.options_user.push(buffer)

          })

        }
        console.log(1111111111)
      }, function(res) {

        _this.options_user =[{text:"全部用户",value:""}]
        _this.loadingOptionUser = false
        console.log(2222222222222222222222222222)
      })
    },
    indexMethod(index) {
      return (
        this.total - this.searchObj.num * (this.searchObj.page - 1) - index
      );
    },
    back() {
      this.$router.back();
    },
    toLockDetail(row) {
      this.$router.push('/order/lockDetail?orderNumber=' + row.order_number + '&itemId=' + row.item_id);
    },
    fuzzySearchClick() {
      this.searchObj.page = 1;
      this.updateRouter();
    },
    updateRouter() {
      this.$router
        .push(
          "/order/lockList?search=" +
            this.formObj.fuzzyQuery +
            "&page=" +
            this.searchObj.page +
            "&size=" +
            this.searchObj.num+
            "&searchBrand=" +
            this.searchBrand+
            "&searchUser=" +
            this.searchUser+
            "&searchUserName="+
            this.searchUserName
        )
    },
    getTableLists() {
      let _this = this;
      this.isLoading = true;
      ajaxPost("/dwOrder/reserverOrderList", {
        supplierUserId: "",
        dealerUserId: "",
        page: this.searchObj.page,
        num: this.searchObj.num,
        fuzzyQuery: this.formObj.fuzzyQuery,
        brand:this.searchBrand,
        queryString:this.searchUser
      }).then(
        function(res) {
          console.log("/dwOrder/reserverOrderList", res);
          _this.tableData = [];
          _this.isLoading = false;
          if (res.errorCode == 200) {
            _this.tableData = res.data.orderList.map(item => {
                return {
                    ...item,
                    productMainImageFile: _this.IMG_PREV + item.productMainImageFile
                }
            })
            _this.total = parseInt(res.data.totalCount)
        } else {
            _this.$message.error(res.errorMsg || '获取列表数据失败')
        }

        },
        function(res) {
          _this.isLoading = false;
        }
      );
    },
    handleSizeChange(size) {
      //分页：每页n条
      this.searchObj.num = size;
      this.searchObj.page = 1;
      this.updateRouter();
    },
    handleCurrentChange(page) {
      //分页：改变第n页
      this.searchObj.page = page;
      this.updateRouter();
    }
  },
  created() {},
  mounted() {
    this.getOptionUser()
    this.getBrandOption()
  }
};
</script>

<style scoped lang="scss">
.searchBox {
  padding: 0.25rem 0.25rem 0;
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
.searchBox:after {
  content: "";
  display: block;
  clear: both;
}
.tableBox {
  padding: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/list-lock.vue